<ng-template #loadingGeneral>

  <mat-spinner class="center"></mat-spinner>
  <p class="center">Loading...</p>

</ng-template>

<ng-template #loadingItem>
  <mat-progress-bar class="center" mode="indeterminate"></mat-progress-bar>
</ng-template>


<div fxLayout="column">


  <ng-container *ngIf="dataSource; else loadingGeneral">

    <div class="w-100 mb-1" fxLayout="row" fxLayoutAlign="center center">

      <mat-form-field *ngIf="dataSource.data.length > 1" class="mb-0">
        <mat-label>Search</mat-label>
        <input #input (keyup)="applyFilters(input.value)" matInput placeholder="">
      </mat-form-field>
      <span fxFlex></span>
      <button *ngIf="!embeddedLayout" (click)="createCompany()" mat-button color="primary">New company
      </button>
    </div>

    <mat-progress-bar *ngIf="loading" class="center" mode="indeterminate"></mat-progress-bar>
    <table (matSortChange)="doSortCompanies($event)" [dataSource]="dataSource" class="w-100 mat-elevation-z2" mat-table
      multiTemplateDataRows matSort>

      <!--- Note that these columns can be defined in any order.
            The actual rendered columns are set as a property on the row definition" -->

      <!-- Position Column -->
      <ng-container class="w-5" matColumnDef="id">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>ID</th>
        <td *matCellDef="let element" mat-cell> {{element.id}} </td>
      </ng-container>

      <!-- Name Column -->
      <ng-container class="w-25" matColumnDef="companyName">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Name</th>
        <td *matCellDef="let element" mat-cell>{{element.companyName}} </td>
      </ng-container>

      <!-- Email Column -->
      <ng-container class="w-25" matColumnDef="companyEmail">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Email</th>
        <td *matCellDef="let element" mat-cell> {{element.companyEmail}} </td>
      </ng-container>

      <!-- Address Column -->
      <ng-container class="w-20" matColumnDef="companyAddress">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Address</th>
        <td *matCellDef="let element" mat-cell> {{element.companyAddress}} </td>
      </ng-container>

      <!-- Action -->
      <ng-container class="w-20" matColumnDef="action">
        <th *matHeaderCellDef mat-header-cell></th>
        <td *matCellDef="let element" mat-cell class="text-right">
          <ng-container *ngIf="!disabledItemId.includes(element.id); else loadingItem">
            <button (click)="details(element)" [disabled]="disabled" mat-icon-button matTooltip="Show details">
              <mat-icon>visibility</mat-icon>
            </button>
            <ng-container *ngIf="!embeddedLayout">
              <button (click)="expandCustomers(element)" [disabled]="disabled" mat-icon-button
                matTooltip="View customers of this company">
                <mat-icon>people</mat-icon>
              </button>
              <button (click)="editCompany(element)" [disabled]="disabled" mat-icon-button matTooltip="Edit company">
                <mat-icon>edit</mat-icon>
              </button>
              <button *awIsInAnyRole="[roles.admin]" (click)="deleteCompany(element)" [disabled]="disabled"
                mat-icon-button matTooltip="Delete company">
                <mat-icon>delete</mat-icon>
              </button>
            </ng-container>
          </ng-container>
        </td>
      </ng-container>


      <ng-container matColumnDef="expandedCustomers">
        <td *matCellDef="let element" [attr.colspan]="displayedColumns.length" mat-cell class="p-1">
          <h3>Customers from {{element.companyName}}</h3>
          <aw-list-customers *ngIf="expandedCustomers == element" [companyId]="element.id"
            [embeddedLayout]="true"></aw-list-customers>
        </td>
      </ng-container>


      <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
      <tr *matRowDef="let row; columns:  displayedColumns" mat-row></tr>
      <tr *matRowDef="let row; columns: ['expandedCustomers']" [fxShow]="expandedCustomers?.id === row.id" mat-row></tr>


      <tr *matNoDataRow class="mat-row">
        <td [colSpan]="displayedColumns.length" class="mat-cell text-center">
          No companies found
        </td>
      </tr>

    </table>
  </ng-container>

  <mat-paginator #paginatorCompanies [fxShow]="dataSource && dataSource.data.length > 10" class="mat-elevation-z1"
    [pageSizeOptions]="[5, 10, 20]" [pageSize]="10" showFirstLastButtons></mat-paginator>
</div>